import createApi from "../utils/axiosInstance";

export const getUserConversationApi = async () => {
  const api = createApi(true);
  const res = await api.get("/user/messaging/conversation");
  return res.data;
};

export const getUserMessagesApi = async (page = 1) => {
  const api = createApi(true);
  const res = await api.get(`/user/messaging/messages?page=${page}`);
  return res.data;
};

export const sendUserMessageApi = async (payload) => {
  const api = createApi(true);
  const res = await api.post("/user/messaging/send", payload);
  return res.data;
};

export const getUserUploadUrlApi = async (filename, fileType) => {
  const api = createApi(true);
  const res = await api.post("/user/messaging/upload-url", { filename, fileType });
  return res.data;
};

export const getAttachmentUrlApi = async (key) => {
  const api = createApi(true);
  const res = await api.post("/user/messaging/attachment-url", { key });
  return res.data;
};
